import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Careers from "@/pages/Careers";
import Stories from "@/pages/Stories";
import Ai from "@/pages/Ai";
import FactoryPage from "@/pages/FactoryPage";
import "@/App.css";

function App() {
  return (
    <div className="grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/ai" element={<Ai />} />
          <Route path="/factory" element={<FactoryPage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
